// GENERATED FILE — do not edit.
//
// Source:      packages/maptool/maps/office.txt
// Regenerate:  npm run maps -w @prop-hunt/maptool
// mapHash:     0xd9e92434
//
// 32 x 24 cells at 2m = 64m x 48m (x -32..32, z -24..24)
// 38 collision solids, 72 props, 12 spawns
//
// Editing this file by hand desynchronises it from the ASCII plan, which is
// the artefact the level actually lives in. Edit the source and regenerate.

import { MAP_FORMAT_VERSION, type GameMap } from "../mapfmt.js";

export const OFFICE_MAP: GameMap = {
  formatVersion: MAP_FORMAT_VERSION,
  name: "office",
  solids: [
    { x: 0, y: -1, z: 0, w: 64, h: 1, d: 48 },
    { x: 0, y: 0, z: -23, w: 64, h: 3, d: 2 },
    { x: -31, y: 0, z: 1, w: 2, h: 3, d: 46 },
    { x: -13, y: 0, z: -16, w: 2, h: 3, d: 12 },
    { x: 1, y: 0, z: -16, w: 2, h: 3, d: 12 },
    { x: 15, y: 0, z: -16, w: 2, h: 3, d: 12 },
    { x: 31, y: 0, z: 1, w: 2, h: 3, d: 46 },
    { x: -24, y: 0, z: -11, w: 12, h: 3, d: 2 },
    { x: -15, y: 0, z: -11, w: 2, h: 3, d: 2 },
    { x: -10, y: 0, z: -11, w: 4, h: 3, d: 2 },
    { x: -3, y: 0, z: -11, w: 6, h: 3, d: 2 },
    { x: 5, y: 0, z: -11, w: 6, h: 3, d: 2 },
    { x: 12, y: 0, z: -11, w: 4, h: 3, d: 2 },
    { x: 19, y: 0, z: -11, w: 6, h: 3, d: 2 },
    { x: 27, y: 0, z: -11, w: 6, h: 3, d: 2 },
    { x: -28, y: 0, z: -5, w: 4, h: 3, d: 2 },
    { x: -16, y: 0, z: -5, w: 16, h: 3, d: 2 },
    { x: 1, y: 0, z: -5, w: 14, h: 3, d: 2 },
    { x: 16, y: 0, z: -5, w: 12, h: 3, d: 2 },
    { x: 27, y: 0, z: -5, w: 6, h: 3, d: 2 },
    { x: -13, y: 0, z: 4, w: 2, h: 3, d: 16 },
    { x: 15, y: 0, z: 4, w: 2, h: 3, d: 16 },
    { x: -26, y: 0, z: 11, w: 8, h: 3, d: 2 },
    { x: -17, y: 0, z: 11, w: 6, h: 3, d: 2 },
    { x: -11, y: 0, z: 11, w: 2, h: 3, d: 2 },
    { x: -1, y: 0, z: 11, w: 14, h: 3, d: 2 },
    { x: 11, y: 0, z: 11, w: 6, h: 3, d: 2 },
    { x: 18, y: 0, z: 11, w: 4, h: 3, d: 2 },
    { x: 26, y: 0, z: 11, w: 8, h: 3, d: 2 },
    { x: -5, y: 0, z: 18, w: 2, h: 3, d: 12 },
    { x: -18, y: 0, z: 23, w: 24, h: 3, d: 2 },
    { x: 13, y: 0, z: 23, w: 34, h: 3, d: 2 },
    { x: -7, y: 0, z: -1, w: 6, h: 1.1, d: 2 },
    { x: 1, y: 0, z: -1, w: 6, h: 1.1, d: 2 },
    { x: 9, y: 0, z: -1, w: 6, h: 1.1, d: 2 },
    { x: -7, y: 0, z: 5, w: 6, h: 1.1, d: 2 },
    { x: 1, y: 0, z: 5, w: 6, h: 1.1, d: 2 },
    { x: 9, y: 0, z: 5, w: 6, h: 1.1, d: 2 },
  ],
  props: [
    { prop: 5, x: -9, y: 0, z: -21, yaw: 5.497787 },
    { prop: 5, x: -5, y: 0, z: -21, yaw: 0.785398 },
    { prop: 5, x: -1, y: 0, z: -21, yaw: 2.356194 },
    { prop: 3, x: 5, y: 0, z: -21, yaw: 4.712389 },
    { prop: 3, x: 9, y: 0, z: -21, yaw: 0 },
    { prop: 3, x: 13, y: 0, z: -21, yaw: 1.570796 },
    { prop: 5, x: 19, y: 0, z: -21, yaw: 3.926991 },
    { prop: 5, x: 23, y: 0, z: -21, yaw: 5.497787 },
    { prop: 5, x: 27, y: 0, z: -21, yaw: 0.785398 },
    { prop: 3, x: -9, y: 0, z: -17, yaw: 3.926991 },
    { prop: 3, x: -5, y: 0, z: -17, yaw: 2.356194 },
    { prop: 3, x: -1, y: 0, z: -17, yaw: 0.785398 },
    { prop: 5, x: 5, y: 0, z: -17, yaw: 3.141593 },
    { prop: 5, x: 9, y: 0, z: -17, yaw: 1.570796 },
    { prop: 5, x: 13, y: 0, z: -17, yaw: 0 },
    { prop: 3, x: 19, y: 0, z: -17, yaw: 5.497787 },
    { prop: 3, x: 23, y: 0, z: -17, yaw: 3.926991 },
    { prop: 3, x: 27, y: 0, z: -17, yaw: 2.356194 },
    { prop: 5, x: -9, y: 0, z: -13, yaw: 2.356194 },
    { prop: 5, x: -5, y: 0, z: -13, yaw: 3.926991 },
    { prop: 3, x: 5, y: 0, z: -13, yaw: 1.570796 },
    { prop: 3, x: 13, y: 0, z: -13, yaw: 4.712389 },
    { prop: 5, x: 19, y: 0, z: -13, yaw: 0.785398 },
    { prop: 5, x: 25, y: 0, z: -13, yaw: 3.141593 },
    { prop: 5, x: 29, y: 0, z: -13, yaw: 4.712389 },
    { prop: 4, x: -21, y: 0, z: -7, yaw: 0 },
    { prop: 4, x: -1, y: 0, z: -7, yaw: 1.570796 },
    { prop: 4, x: 21, y: 0, z: -7, yaw: 5.497787 },
    { prop: 6, x: -27, y: 0, z: -3, yaw: 3.926991 },
    { prop: 6, x: -23, y: 0, z: -3, yaw: 2.356194 },
    { prop: 1, x: -19, y: 0, z: -3, yaw: 0.785398 },
    { prop: 1, x: -15, y: 0, z: -3, yaw: 5.497787 },
    { prop: 2, x: 19, y: 0, z: -1, yaw: 5.497787 },
    { prop: 2, x: 23, y: 0, z: -1, yaw: 3.926991 },
    { prop: 2, x: 27, y: 0, z: -1, yaw: 2.356194 },
    { prop: 6, x: -27, y: 0, z: 1, yaw: 2.356194 },
    { prop: 6, x: -23, y: 0, z: 1, yaw: 3.926991 },
    { prop: 1, x: -19, y: 0, z: 1, yaw: 5.497787 },
    { prop: 1, x: -15, y: 0, z: 1, yaw: 0.785398 },
    { prop: 5, x: -9, y: 0, z: 1, yaw: 1.570796 },
    { prop: 5, x: 7, y: 0, z: 1, yaw: 1.570796 },
    { prop: 2, x: 19, y: 0, z: 3, yaw: 0.785398 },
    { prop: 2, x: 23, y: 0, z: 3, yaw: 2.356194 },
    { prop: 2, x: 27, y: 0, z: 3, yaw: 3.926991 },
    { prop: 4, x: -27, y: 0, z: 5, yaw: 0.785398 },
    { prop: 4, x: -23, y: 0, z: 5, yaw: 5.497787 },
    { prop: 3, x: -9, y: 0, z: 7, yaw: 0.785398 },
    { prop: 3, x: 7, y: 0, z: 7, yaw: 0.785398 },
    { prop: 1, x: 19, y: 0, z: 7, yaw: 2.356194 },
    { prop: 1, x: 23, y: 0, z: 7, yaw: 0.785398 },
    { prop: 1, x: 27, y: 0, z: 7, yaw: 5.497787 },
    { prop: 1, x: -27, y: 0, z: 9, yaw: 5.497787 },
    { prop: 1, x: -23, y: 0, z: 9, yaw: 0.785398 },
    { prop: 4, x: -27, y: 0, z: 13, yaw: 3.926991 },
    { prop: 4, x: -23, y: 0, z: 13, yaw: 2.356194 },
    { prop: 4, x: -19, y: 0, z: 13, yaw: 0.785398 },
    { prop: 4, x: -15, y: 0, z: 13, yaw: 5.497787 },
    { prop: 4, x: -11, y: 0, z: 13, yaw: 3.926991 },
    { prop: 5, x: -1, y: 0, z: 15, yaw: 0.785398 },
    { prop: 5, x: 3, y: 0, z: 15, yaw: 5.497787 },
    { prop: 3, x: 7, y: 0, z: 15, yaw: 3.926991 },
    { prop: 3, x: 11, y: 0, z: 15, yaw: 2.356194 },
    { prop: 2, x: 15, y: 0, z: 15, yaw: 0.785398 },
    { prop: 2, x: 19, y: 0, z: 15, yaw: 5.497787 },
    { prop: 1, x: 23, y: 0, z: 15, yaw: 3.926991 },
    { prop: 1, x: 27, y: 0, z: 15, yaw: 2.356194 },
    { prop: 6, x: -27, y: 0, z: 17, yaw: 2.356194 },
    { prop: 6, x: -23, y: 0, z: 17, yaw: 3.926991 },
    { prop: 6, x: -19, y: 0, z: 17, yaw: 5.497787 },
    { prop: 2, x: -27, y: 0, z: 21, yaw: 0.785398 },
    { prop: 2, x: -23, y: 0, z: 21, yaw: 5.497787 },
    { prop: 2, x: -19, y: 0, z: 21, yaw: 3.926991 },
  ],
  spawns: [
    { x: -27, y: 0, z: -19, yaw: 1.570796, team: "hunter" },
    { x: -23, y: 0, z: -19, yaw: 1.570796, team: "hunter" },
    { x: -19, y: 0, z: -19, yaw: 1.570796, team: "hunter" },
    { x: -27, y: 0, z: -15, yaw: 1.570796, team: "hunter" },
    { x: -23, y: 0, z: -15, yaw: 1.570796, team: "hunter" },
    { x: -19, y: 0, z: -15, yaw: 1.570796, team: "hunter" },
    { x: -1, y: 0, z: 19, yaw: -0.052583, team: "hider" },
    { x: 3, y: 0, z: 19, yaw: 0.156602, team: "hider" },
    { x: 7, y: 0, z: 19, yaw: 0.35299, team: "hider" },
    { x: 19, y: 0, z: 19, yaw: 0.785398, team: "hider" },
    { x: 23, y: 0, z: 19, yaw: 0.88035, team: "hider" },
    { x: 27, y: 0, z: 19, yaw: 0.957589, team: "hider" },
  ],
};
